// Set to true and rebuild to restore PWA installation and browser push notifications.
export const PWA_ENABLED = false;

export const initializePwa = async (enabled = PWA_ENABLED) => {
    const workerUrl = new URL(`${process.env.PUBLIC_URL}/sw.js`, window.location.href).href;

    if (enabled) {
        const manifest = document.createElement('link');
        manifest.rel = 'manifest';
        manifest.crossOrigin = 'use-credentials';
        manifest.href = `${process.env.PUBLIC_URL}/manifest.json`;
        document.head.appendChild(manifest);
        if ('serviceWorker' in navigator) {
            await navigator.serviceWorker.register(workerUrl);
        }
        return;
    }

    window.addEventListener('beforeinstallprompt', (event) => event.preventDefault());
    if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.filter((registration) =>
            [registration.active, registration.waiting, registration.installing]
                .some((worker) => worker?.scriptURL === workerUrl)
        ).map((registration) => registration.unregister()));
    }
    if ('caches' in window) {
        const names = await caches.keys();
        await Promise.all(names.filter((name) => name.startsWith('pofbusiness-cache'))
            .map((name) => caches.delete(name)));
    }
};
